import { render, staticRenderFns } from "./objectModelView.vue?vue&type=template&id=40274f78&scoped=true&"
import script from "./objectModelView.vue?vue&type=script&lang=js&"
export * from "./objectModelView.vue?vue&type=script&lang=js&"
import style0 from "./objectModelView.vue?vue&type=style&index=0&id=40274f78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40274f78",
  null
  
)

export default component.exports